var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.questions),function(question){return _c('button',{staticClass:"btn btn--link faq__item",on:{"click":function($event){return _vm.openAnswer(question)}}},[_vm._v("\n        "+_vm._s(question.answer_title)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }